import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fadeIn, staggerContainer } from "@/lib/animations";

export function DemoSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-violet-900 to-violet-800 overflow-hidden">
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.25 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative"
      >
        {/* Background decorations */}
        <div className="absolute -top-20 -right-20 w-64 h-64 bg-white opacity-5 rounded-full"></div>
        <div className="absolute -bottom-20 -left-20 w-80 h-80 bg-white opacity-5 rounded-full"></div>
        
        <motion.div 
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="text-center max-w-3xl mx-auto mb-16 relative z-10"
        >
          <h2 className="text-3xl md:text-4xl font-light text-white">
            <span className="text-violet-300">Vettor's</span> AI Agent Workflow for Recruiters
          </h2>
          <p className="mt-6 text-xl text-gray-200 font-light">Streamline your recruiting process and save countless hours with our AI agents that handle repetitive tasks, letting you focus on finding the perfect candidates</p>
        </motion.div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
          <motion.div
            variants={fadeIn("right", "tween", 0.3, 1)}
            className="rounded-xl overflow-hidden shadow-2xl border border-violet-700 relative"
          >
            <img 
              src="https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&h=500&q=80" 
              alt="Team discussing candidate profiles" 
              className="w-full"
            />
          </motion.div>
          
          <motion.div
            variants={fadeIn("left", "tween", 0.4, 1)}
            className="space-y-8 text-white p-4 md:p-6"
          >
            <div className="space-y-4">
              <h3 className="text-2xl font-light text-violet-300">Start Seeing Results Day One</h3>
              <p className="text-gray-200 font-light">Connect your existing recruiting tools, define your workflow, and let our AI agents handle time-consuming tasks. Free your recruiting team to focus on what really matters - building relationships.</p>
            </div>
            <div className="space-y-5 my-8">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-violet-400 rounded-full flex items-center justify-center mt-1">
                  <Check className="w-4 h-4 text-violet-900" />
                </div>
                <span className="text-gray-200 font-light">AI-powered candidate sourcing and outreach</span>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-violet-400 rounded-full flex items-center justify-center mt-1">
                  <Check className="w-4 h-4 text-violet-900" />
                </div>
                <span className="text-gray-200 font-light">Automated screening and skills assessment</span>
              </div>
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-6 h-6 bg-violet-400 rounded-full flex items-center justify-center mt-1">
                  <Check className="w-4 h-4 text-violet-900" />
                </div>
                <span className="text-gray-200 font-light">Smart scheduling and interview coordination</span>
              </div>
            </div>
            <a href="#contact">
              <Button size="lg" className="bg-violet-400 text-violet-900 hover:bg-violet-300 border-0 font-light mt-4">
                Request Early Access
              </Button>
            </a>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
}
